import React, { useState, useEffect } from 'react';
import { supabase } from '../utils/supabaseClient';

const Beforehand1 = ({ setStep, setFormData, hospitalId }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    sessionStorage.setItem('lastPage', 'Beforehand1');
    
    // 初期値を設定
    setFormData(prev => ({
      ...prev,
      osteoporosisTreatment: null,
      boneDensityTest: null
    }));
    
    // セッションのリセットチェック - 前のセッションが完了しているか、ページ更新かをチェック
    const isCompletedSession = sessionStorage.getItem('session_completed') === 'true';
    const isPageRefresh = performance.navigation && performance.navigation.type === 1;
    
    // 既存のセッションIDをチェック
    const existingId = sessionStorage.getItem('session_id');
    const isValidUUID = existingId && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(existingId);
    
    if (isCompletedSession || isPageRefresh || (existingId && !isValidUUID)) {
      console.log('Beforehand1: 前のセッションは完了しているか、ページが更新されたか、無効なセッションIDが検出されました。セッションIDをクリアします。');
      sessionStorage.removeItem('session_id');
      sessionStorage.removeItem('session_completed');
    }
  }, [setFormData]);

  const handleAnswer = async (answer) => {
    if (isSubmitting) return;
    
    setIsSubmitting(true);
    setFormData(prev => ({ ...prev, osteoporosisTreatment: answer === 'yes' }));

    try {
      // 既存のセッションIDがあれば削除（常に新しいセッションを作成するため）
      const existingSessionId = sessionStorage.getItem('session_id');
      if (existingSessionId) {
        console.log('既存のセッションIDを削除し、新しいセッションを作成します');
        sessionStorage.removeItem('session_id');
      }
      
      // セッションを新規作成（セッション開始時点）
      try {
        const { data, error } = await supabase
          .from('sessions')
          .insert([{ 
            hospital_id: hospitalId
          }])
          .select('id');

        if (error) {
          console.error('Supabase session insert error:', error);
          // エラー時は一時的なUUID形式のIDを使用
          const tempSessionId = `temp-${crypto.randomUUID ? crypto.randomUUID() : Date.now()}`;
          sessionStorage.setItem('session_id', tempSessionId);
          console.log('エラーのため一時的なセッションIDを使用:', tempSessionId);
        } else if (data && data.length > 0) {
          const sessionId = data[0].id;
          sessionStorage.setItem('session_id', sessionId);
          console.log('新しいセッションを作成しました:', sessionId);
        } else {
          console.error('セッション作成に失敗: データが返されませんでした');
          const tempSessionId = `temp-${crypto.randomUUID ? crypto.randomUUID() : Date.now()}`;
          sessionStorage.setItem('session_id', tempSessionId);
        }
      } catch (error) {
        console.error('セッション開始エラー:', error);
        // 例外発生時も一時的なUUID形式のIDを使用
        const tempSessionId = `temp-${crypto.randomUUID ? crypto.randomUUID() : Date.now()}`;
        sessionStorage.setItem('session_id', tempSessionId);
        console.log('エラーのため一時的なセッションIDを使用:', tempSessionId);
      }

      // セッション開始の成功/失敗に関わらず次の画面に進む
      if (answer === 'yes') {
        setStep(14); // ThankYou画面へ
      } else {
        setStep(1); // Beforehand2へ
      }
    } catch (error) {
      console.error('予期しないエラー:', error);
      // 重大なエラーでも次の画面に進む（UXを優先）
      if (answer === 'yes') {
        setStep(14);
      } else {
        setStep(1);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-4 bg-blue-100 rounded-lg">
      <h2 className="common-title mb-4">はじめに 1</h2>
      <p className="text-base mb-4 text-lg text-red-500">このチェックを始める前に、以下の質問にお答えください。</p>
      <p className="text-base mb-4 text-lg">1. あなたは現在、骨粗しょう症の治療中ですか？</p>
      <br />
      <div className="flex justify-between">
        <button 
          onClick={() => handleAnswer('yes')}
          className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 w-auto"
          disabled={isSubmitting}
        >
          はい
        </button>
        <button 
          onClick={() => handleAnswer('no')}
          className="bg-pink-500 text-white p-2 rounded hover:bg-pink-600 w-auto"
          disabled={isSubmitting}
        >
          いいえ
        </button>
      </div>
    </div>
  );
};

export default Beforehand1; 